import './Price.less'
//import Button from '../../../Button'
import Rating from '../../../Rating';

export function ProductPrice({
  product,
  price = product?.price,
  qty,
  setQty,
  addToCartHandler,
}) {
  const currentPrice = price ?? product?.price ?? 0;
  const hasRating = product.rating > 0;

  return (
    // <div className="card-detail card-body">
    <div>
      <ul>
        <li>
          <div className="product-header">
            <span>Marca · Código de artículo</span>
            <h2>{product.name}</h2>
            <span>Calificaciones</span>
            {hasRating ? (
              <>
                <Rating
                  rating={product.rating}
                  numReviews={product.numReviews}
                ></Rating>
              </>


            ) : (
              <>
                <Rating
                  rating={0}
                  numReviews={0}
                ></Rating>
                <span>Sin Calificaciones</span>

              </>


            )



            }

          </div>
        </li>

        <li>
          <div className="product-details">
            <h2>Price</h2>
            <span>${product.price}</span>
            <p>Variantes y disponibilidad</p>
            <p>Información de envíos</p>
            <p>Garantía y soporte</p>
            <p>Medios de pago</p>
          </div>
        </li>
        <li>
          <div className="products">
            {/* <div>Status</div> */}
            <div>
              {/* {product.countInStock > 0 ? (
                <span className="success">In Stock</span>
              ) : (
                <span className="danger">Unavaible</span>
              )} */}
            </div>
          </div>
        </li>

        {product?.countInStock > 0 && (
          <>
            <li>
              {/* <div className="products">
                <div>Qty</div>
                <div>
                  <select
                    value={qty}
                    onChange={e => setQty(Number(e.target.value))}
                  >
                    {[...Array(product.countInStock).keys()].map(
                      x => (
                        <option key={x + 1} value={x + 1}>
                          {x + 1}
                        </option>
                      )
                    )}
                  </select>
                </div>
              </div> */}
            </li>
            <li>
              {/* <button
                onClick={addToCartHandler}  
                className="btn block"
              >
                {' '}
                Add to Cart
              </button> */}
              {/* <Button onClick={addToCartHandler}> Add to Cart</Button> */}
            </li>
          </>
        )}
      </ul>
    </div >
  )
}